/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const StatisticProductPage = lazyLoad(
  () => import('./index'),
  module => module.StatisticProductPage
);
